<template>
  <v-app id="admin-app">
    <nav-bar
      currentProduct="admin"
      :enabledApps="enabledApps"
      showAdmin
      @sign-out="logout"
      :support-url="supportUrl"
      :support-contact-url="supportContactUrl"
      :userName="userName"
      :userInfo="userInfo"
      :sideLinks="sideMenu"
      @secret-meta-click="impersonate"
    >
      <div slot="body" class="appBody styleScroll">
        <div class="navbar-slot">
            <div class="collector-panel">
              <collection-status-panel></collection-status-panel>
            </div>
            <div class="org-change-field" v-if="isSU">
              <v-autocomplete
                clearable
                v-model="orgid"
                :items="organizations"
                label="Organization"
                item-text="text"
                item-value="value"
                @change="orgChange"
                :disabled="orgSelectionLock">
              </v-autocomplete>
            </div>
        </div>
        <div class="content-wrapper main-content-container nav-footer-fix">
            <router-view></router-view>
        </div>
      </div>
    </nav-bar>
    <impersonation-panel
        :show="showImpersonate"
        @impersonate-complete="reset"
    >
    </impersonation-panel>
  </v-app>
</template>

<script>
  import BrandingService from '../../../../services/branding.service';
  import LoginService from  '../../../../services/login.service';
  import NavBar from '../../../../vueComponents/navBar/src/navBar';
  import ImpersonationPanel from '../../../../components/nav-bar/impersonationPanel.vue';
  import StatusBar from './StatusBar.vue';
  import UserProfile from '../Users/UserProfile.vue';
  import CollectionStatusPanel from '../Collector/CollectionStatusPanel.vue';
  import { mapState, mapActions, mapGetters } from 'vuex';
  export default {
    components: {
      'nav-bar': NavBar,
      'impersonation-panel': ImpersonationPanel,
      'status-bar': StatusBar,
      'user-profile': UserProfile,
      'collection-status-panel': CollectionStatusPanel
    },
    computed: {
        ...mapGetters('user', {
            organizations: 'getOrganizationsTextValue',
            isSU: 'isSU',
            orgContext: 'getOrgContext',
            orgContextName: 'getOrgContextName',
            name: 'getName',
            email: 'getEmail',
            userName: 'getUsername',
            userInfo: 'getUserInfo',
            orgName: 'getOrgName',
            orgId: 'getOrgId',
            orgDomain: 'getOrgDomain',
            timezone: 'getOrgTimezone',
            orgSelectionLock: 'getOrgSelectionLock',
            modulesDictionary: 'getModulesDictionary'
        }),
        ...mapGetters('menus', {
          findRouteTitle: 'findRouteTitle'
        }),
        ...mapGetters('menus', {
            sideLinks: 'getMenu'
        }),
        routeTitle: {
          get() {
            return this.findRouteTitle(this.$route.name) || this.title
          }
        },
        sideMenu: function () {
          return [{
            id: 'admin',
            name: 'Admin',
            icon: 'far fa-toolbox fa-fw',
            views: this.sideLinks.map(link => {
            return {
              name: link.title,
              url: link.url,
              // icon: link.icon
            }
            })
          }];
        },
        enabledApps: function() {
          let enabledApps = []
          let dict = this.modulesDictionary
          if (dict) {
            if (dict['Assurance'])         { enabledApps.push('monitoring') }
            if (dict['AdvancedAnalytics']) { enabledApps.push('analytics') }
            if (dict['RoomInsights'])      { enabledApps.push('workspaces') }
          }
          return enabledApps
        }
    },
    async created () {
      let self = this;

      await LoginService.authPromise;
      if (this.isSU) {
        await this.$store.dispatch('user/getOrganizations');
      }
      this.$store.dispatch("collectors/getCollectorLatestVersion");
      this.$store.dispatch('user/getAppConfigs');
    },
    async updated() {
      this.orgid = this.orgContext
    },
    beforeRouteUpdate(to, from, next) {
      // this.lockOrgSelection = !!to.meta.disableOrgSelection
      this.$store.dispatch('user/updateOrgSelectionLock', !!to.meta.disableOrgSelection)
      next()
    },
    data () {
      return {
        clipped: true,
        drawer: true,
        fixed: false,
        title: 'WXP Collaboration CPM Data Collector Configuration',
        orgid: null,
        // lockOrgSelection: false,
        thisYear: (new Date()).getFullYear(),
        supportUrl: BrandingService.getSupportUrl(),
        supportContactUrl: BrandingService.getSupportContactUrl(),
        showImpersonate: false,
      }
    },
    beforeMount() {
      let self = this;
    },
    methods: {
      async orgChange(val) {
        // todo need to fix UX here as vuetify now calls this when item deleted but no other item selected
        if (val && !confirm('Do you want to impersonate ' + val + '?')) {
          return false
        }

        this.$store.dispatch('user/initialize');
        this.$store.dispatch('systems/initialize');
        this.$store.dispatch('endpoints/initialize');
        this.$store.dispatch('status/initialize');
        this.$store.dispatch('collectors/initialize');
        this.$store.dispatch('menus/setMenus');
        this.$store.dispatch("collectors/getCollectorLatestVersion");
        
        await this.$store.dispatch('user/setOrganizationContext', val);

        this.$store.dispatch('user/getAppConfigs');
        var objActivity = {
          action: 'impersonation',
          appId: 'cpm-admin',
          view: this.$route.name,
          tab: '',
          url: window.location.href,
          source: this.$route.path,
          details: 'impersonating orgId ' + val + ' (' + (this.orgContextName || this.orgName) + ')',
          data: JSON.stringify({orgId: val, orgName: this.orgContextName || this.orgName}),
        };
        this.$store.dispatch('status/logActivity', objActivity);
      },
      async logout() {
        await this.$store.dispatch('user/logout');
        this.$router.replace({ path: "/" });
      },
      impersonate() {
        if (LoginService.userObject.isSu() || LoginService.userObject.isSuPro() ) {
          // open impersonate dialog
          this.showImpersonate = true;
        }
      },
      reset: function() {
        this.showImpersonate = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-footer--fixed {
    z-index: 7!important;
  }

  .nav-footer-fix {
    border-top: unset;
    z-index: unset;
  }
  .main-content-container {
    // top padding is hidden under the navbar and acts as a spacer only
    padding: 20px 32px;
  }
  .navbar-slot {
    width: 600px;
    height: 60px;
    max-width: calc(100% - 203px);
    display: inline-block;
    background-color: var(--panel-background);
    border-radius: var(--border-radius);
    padding: 6px 15px;
    margin: auto;
    margin-top: 15px;
    margin-left: 25%;

    .collector-panel {
      display: inline-block;
      width: 49%;
      height: 50px;
    }
    .org-change-field {
      margin-top: 5px;
      display: inline-block;
      width: 49%;
    }
  }
</style>
<style lang="scss">
/* vuetify overrides */
.org-change-field {
  .v-text-field {
    padding: 0;
    margin: 0 4px;
    position: relative;
    top: 6px;
  }
}

.v-application--wrap {
  /* Vue transition styles */
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    transition: opacity 0.2s 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .fade-leave-to {
    opacity: 0;
  }
  .fade-leave-active {
    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
}

.actions .v-btn {
  margin: 10px;
}

#admin-app {
  .appBody {
    width: calc(100% - var(--side-bar-width));
    height: 100vh;
    overflow-y: auto;
    display: inline-block;
    color: var(--text-color);
    flex-grow: 1;
    background-color: var(--background-color);
  }
}
</style>
